var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"flex-1 overflow-x-hidden overflow-y-auto px-2"},[_c('div',{attrs:{"id":"chatsoptifylatest"}},[_c('h1',[_vm._v("Loading .....")])])])
}]

export { render, staticRenderFns }